<div class="offer-lc-container page-container">
  <h1 class="bold">Lupul schimba blana, dar naravul ba!</h1>
  <h2 style="align-items: center; display: flex;"><mat-icon>color_lens</mat-icon>Se pregateste un nou design!	<mat-icon> brush</mat-icon></h2>
  <p>Intre timp, ne poti urmari pe:
    <a href="https://www.instagram.com/lupulcreativ">Instagram, </a>
    <a href="https://www.facebook.com/lupulcreativ">Facebook, </a>
    <a href="https://www.tiktok.com/@lupulcreativ">Tik Tok</a>
  </p>
</div>
